<div class="modal-dialog-wrapper" appDialogSelectable appDialogKeyboardEnabled
     [appDialogMinimizable]='MinimizableDialogType.CaseEconomyRecoveryPayment'>

  <mat-dialog-content (cdkDragStarted)='dialogBoundryService.handleDragStart($event)'
                      (cdkDragEnded)='dialogBoundryService.handleDragEnd($event)'
                      cdkDragRootElement='.cdk-overlay-pane' cdkDrag>
    <div appDialogDragArea cdkDragHandle></div>

    <app-coordination-case-split (closeCoordinationCaseSplit)='close()' [supplierInvoiceId]="data.supplierInvoiceId" [caseId]="data.caseId"/>

  </mat-dialog-content>
</div>
